<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/jSdEmL/tc-custom/9780312268329.jpg?1725275975024" alt="This image is the cover for the book Fail-Safe Investing"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Fail-Safe Investing
      </h1>
      <p class="bookDescription body article font2">
        <p>Do you worry that you're not paying enough attention to your investments? Do you feel left out when you hear about the clever things other investors seem to be doing? Relax. You don't have to become an investment genius to protect your savings. Distilling the wisdom of his thirty years' experience into lessons that can be applied in thirty minutes, Harry Browne shows you what you need to know to make your savings and investments safe and profitable, no matter what the economy and the investment markets do. There are no secret trading systems here, no jargon to learn. Instead, Harry Browne teaches you in simple terms to, among other things:<br/><br/>-Build your wealth on your career<br/>-Make your own decisions<br/>-Build a bulletproof portfolio for protection<br/>-Take advantage of tax-reduction plans<br/>-Enjoy yourself with a budget for pleasure</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Harry Browne
      </h2>
      
      <p class="authorDescription body article"><B>Harry Browne (1933-2006) </B>was one of America's best-known investment advisers, the author of a dozen investment and political books (including <I>Why the Government Doesn't Work </I>and <I>How I Found Freedom in an Unfree World)</I>, a radio personality, and the 2000 Libertarian candidate for president. He lived in Tennessee.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      St . Martin’S Qhiffin
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?ecbb5268